import { render } from "./RegisterMain.vue?vue&type=template&id=65769677&ts=true"
import script from "./RegisterMain.vue?vue&type=script&lang=ts"
export * from "./RegisterMain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__